import React, { useState } from 'react';
import { Modal } from 'h-commons';
import { Prompt, useHistory } from 'react-router-dom';
import { Typography, theme } from '@hiver/hiver-ui-kit';

let nextLocation = null;

export const NavigationPromtModal = ({shown, title, description, modalContent, onLeave, onStay, ...rest}) => {
    return(
        <Modal
            shown={shown}
            modalContent={modalContent || getModalContent(title, description, rest)}
            leftBtnText="Stay"
            rightBtnText="Leave"
            leftBtnHandler={onStay}
            rightBtnHandler={onLeave}
            leftBtnType="cancel"
            rightBtnType="warning"
        />
    )
}

NavigationPromtModal.defaultProps = {
    title: 'Are you sure you want to leave this page?',
    description: 'Your setup is incomplete. Complete your setup to save or discard the changes you’ve made.',
};


export const NavigationPrompt = ({ active, title, description, ignorePath, ...rest }) => {
    const [show, setShow] = useState(false);
    const history = useHistory();

    const onLeave = () => {
        if (nextLocation) {
            setShow(false);
            history.push(nextLocation);
        }
    };

    const handleBlockedNavigation = (location) => {
        nextLocation = location;
        if (Array.isArray(ignorePath) && ignorePath.some(item => nextLocation?.pathname?.includes(item))) {
            return true;
        }
        if (!show) {
            setShow(true);
            return false;
        }
        return true;
    };

    return (
        <React.Fragment>
            <Prompt when={active} message={handleBlockedNavigation} />
            <NavigationPromtModal
                shown={show}
                modalContent={getModalContent(title, description, rest)}
                onStay={() => setShow(false)}
                onLeave={onLeave}
            />
        </React.Fragment>
    );
};

NavigationPrompt.defaultProps = {
    title: 'Are you sure you want to leave this page?',
    description: 'Your setup is incomplete. Complete your setup to save or discard the changes you’ve made.',
};

const getModalContent = (title, description, rest) => {
    return (
        <div {...rest}>
            <p className="h-h2" style={{ textAlign: 'center' }}>
                <Typography variant="h3">{title}</Typography>
            </p>
            <p className="h-s3" style={{ textAlign: 'center' }}>
                <Typography variant="body2" sx={{color: theme.palette.gray.gray3}}>{description}</Typography>
            </p>
        </div>
    );
};
